import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendRequirements } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendRequirementsState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number;
}

// 初期状態
export const jobRecommendListForTrendRequirementsInitialState: JobRecommendListForTrendRequirementsState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendRequirementsSlice = createSlice({
  name: 'jobRecommendListForTrendRequirements',
  initialState: jobRecommendListForTrendRequirementsInitialState,
  reducers: {
    setInitialDisplayFlagRequirements: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobListForTrendRequirements.pending, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(
      getJobListForTrendRequirements.fulfilled,
      (state, action) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
        state.jobRecommendListForTrend.entity = action.payload;
      }
    );
    builder.addCase(getJobListForTrendRequirements.rejected, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
    });
  },
});

// Create Action
export const { setInitialDisplayFlagRequirements } =
  jobRecommendListForTrendRequirementsSlice.actions;

// reducer
export const jobRecommendListForTrendRequirementsReducer =
  jobRecommendListForTrendRequirementsSlice.reducer;

interface State {
  jobRecommendListForTrendRequirements: JobRecommendListForTrendRequirementsState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendRequirementsLoadingSelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendRequirements?.jobRecommendListForTrend.loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendRequirementsEntitySelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendRequirements?.jobRecommendListForTrend.entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagRequirementsSelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendRequirements.initialDisplayFlag;
